export default {"src":"/assets/turbo/b2a6424a/quellede/_next/static/media/favicon.5306d79d.ico","height":16,"width":16,"blurWidth":0,"blurHeight":0};